import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * RoomsRedirect Component
 *
 * This component handles redirects from mobile web room selection URLs
 * to the corresponding hotel detail pages in desktop web.
 *
 * Transforms:
 * /hotels/searches/drv/2025-10-16/2025-10-17/1642639/rooms
 * To:
 * /hotels/searches/drv/2025-10-16/2025-10-17/1642639
 */
const RoomsRedirect: React.FC = (): null => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.endsWith('/rooms')) {
      const hotelDetailPathname = pathname.replace('/rooms', '');

      navigate(
        {
          pathname: hotelDetailPathname,
          search: '',
        },
        { replace: true },
      );
    }
  }, [pathname, navigate]);

  return null;
};

export default RoomsRedirect;
